module.exports = __webpack_public_path__ + "static/media/help.f3d85ac3.svg";